// Define the report data interface
export interface ReportPdfData {
  // Basic report details
  title: string;
  authorName?: string;
  authorEmail: string;
  ownerRole?: string;
  selectedSections: string[];
  salesContact?: string;
  salesContactName?: string;
  salesContactInfo?: {
    id: string;
    name?: string;
    email: string;
    role?: string;
    phone?: string;
    photo_url?: string;
  };
  
  // Project details
  projectId: string;
  projectName: string;
  projectDescription?: string;
  createdAt: string;
  nodeCount: number;
  edgeCount: number;
  
  // Content sections
  architecture?: {
    nodes: Array<{ type: string; label: string; description?: string }>;
  };
  modules?: Array<{ name: string; description: string; enabled: boolean }>;
  destinations?: Array<{ 
    name: string; 
    category?: string; 
    description?: string;
    icon?: string;
    docs?: string | string[] | Array<{ label: string, url: string }> | { links: Array<{ label: string, url: string }> };
    supportsSyncInjector?: boolean;
    nodes?: Array<{
      id?: string;
      label?: string;
      status?: string;
      customLabel?: string;
      teamAccess?: string;
      latencyImpact?: number | string | null;
      schema?: string;
      [key: string]: any; // Allow for any additional node-specific fields
    }>;
  }>;
  
  // Section content (markdown)
  sectionContent?: Record<string, string>;
  
  // Link to interactive version
  shareLink?: string;
}

// PDF document colors
export const pdfColors = {
  primary: '#338CF1',
  primaryDark: '#0B70E0',
  secondary: '#272236',
  lightGrey: '#D7D8E5',
  mediumGrey: '#6A6C81',
  darkGrey: '#525365',
  bgGrey: '#F5F5FA',
  white: '#FFFFFF',
  black: '#272236',
  error: '#FF0000'
};
